import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import {
  landing as landingRoutes,
  dashboard as dashboardRoutes,
  page as pageRoutes,
} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import LandingLayout from "../layouts/Landing";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import Page405 from "../pages/auth/Page405";
import Page406 from "../pages/auth/Page406";
import SignIn from "../pages/auth/SignIn";
import ResetPassword from "../pages/auth/ResetPassword";
import Organizationqrcode from "../pages/auth/Organizationqrcode";
import ApplyLeave from "../pages/auth/applyLeave";
import ApplyOt from "../pages/auth/applyOT";
import SignUp from "../pages/auth/SignUp";
import ScrollToTop from "../components/ScrollToTop";

/**
 * Render a route with its configured layout.
 * Supports both direct routes and the existing nested `children` format.
 */
const renderRoute = (Layout, route, key, child = null) => {
  const routeConfig = child || route;
  const { path, component: Component } = routeConfig;

  if (!Component) return null;

  return (
    <Route
      key={key}
      path={path}
      exact
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

const childRoutes = (Layout, routes) =>
  routes.flatMap((route, routeIndex) => {
    const { children } = route;

    if (Array.isArray(children) && children.length) {
      return children.map((child, childIndex) =>
        renderRoute(Layout, route, `${routeIndex}-${childIndex}-${child.path}`, child)
      );
    }

    return renderRoute(Layout, route, `${routeIndex}-${route.path}`);
  });

const AuthFallback = () => {
  // Read localStorage once per fallback render instead of repeatedly.
  const uname = localStorage.getItem("uname");
  const loginType = localStorage.getItem("login_type");
  const jobUrlComp = localStorage.getItem("joburlcomp");

  const flags = {
    signup: localStorage.getItem("signup") === "1",
    forget: localStorage.getItem("forget") === "1",
    scan: localStorage.getItem("scan") === "1",
    leave: localStorage.getItem("leave") === "1",
    ot: localStorage.getItem("ot") === "1",
  };

  if (uname && !jobUrlComp) {
    if (loginType === "hr_admin" || loginType === "sub_admin") {
      return <Page404 />;
    }

    if (loginType === "emp") {
      return <Page405 />;
    }

    if (loginType === "security") {
      return <Page406 />;
    }
  }

  if (flags.signup) return <SignUp />;
  if (flags.forget) return <ResetPassword />;
  if (flags.scan) return <Organizationqrcode />;
  if (flags.leave) return <ApplyLeave />;
  if (flags.ot) return <ApplyOt />;

  return <SignIn />;
};

const Routes = () => (
  <Router>
    <ScrollToTop>
      <Switch>
        {childRoutes(LandingLayout, landingRoutes)}
        {childRoutes(DashboardLayout, dashboardRoutes)}
        {childRoutes(AuthLayout, pageRoutes)}

        <Route
          render={() => (
            <AuthLayout>
              <AuthFallback />
            </AuthLayout>
          )}
        />
      </Switch>
    </ScrollToTop>
  </Router>
);

export default Routes;
